<!-- Page header + close -->
<div class="page-header">
  <button tabindex="-1" class="back-button" mat-flat-button (click)="close()">
    <mat-icon class="notranslate">chevron_left</mat-icon>
    <span class="back-button-label">Back</span>
  </button>
  <div class="file-name-header">
    <h1 class="file-name lo_sensitive" *ngIf="storageObject$ | async as storageObject" [matTooltip]="storageObject.displayName" matTooltipClass="terra-tooltip-wide"
        matTooltipPosition="above">
      {{ storageObject.displayName | truncate : 45}}.{{storageObject.extension}}
    </h1>
  </div>
</div>

<div class="page-content">
  <ng-container *ngIf="{
    generalMediaType : generalMediaType$ | async,
    storageObject: storageObject$ | async } as data">

    <!-- Filestack viewer injected here (for documents/any file that can be converted to pdf, images also)   -->
    <div id="filePreviewFrame"
         [class.hide]="data.generalMediaType === GeneralMediaType.Video || data.generalMediaType === GeneralMediaType.Audio">
    </div>


    <!-- HTML 5 players -->
    <ng-container *ngIf="data.generalMediaType === GeneralMediaType.Video || data.generalMediaType === GeneralMediaType.Audio">
      <ng-container *ngIf="isAudioOrVideoSupportedForPreview(data.storageObject,  data.generalMediaType) else notSupported">
        <video *ngIf="data.generalMediaType === GeneralMediaType.Video" controls>
          <source [src]="fullUrlWithCredentials$ | async" [type]="data.storageObject?.metaFileLink.mediaType">
        </video>
        <audio *ngIf="data.generalMediaType === GeneralMediaType.Audio" controls>
          <source [src]="fullUrlWithCredentials$ | async" [type]="data.storageObject?.metaFileLink.mediaType">
        </audio>
      </ng-container>
      <ng-template #notSupported>
        <div class="preview-not-supported">
          <p>No preview available, download the file directly.</p>
          <button mat-flat-button color="primary" (click)="dowload(data.storageObject)">
            <mat-icon class="notranslate">get_app</mat-icon>
            Download file
          </button>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>
